import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { ContainerComponent } from '../../layout/container/container.component';
import { AnalyticsService } from '../../../services/analytics.service';

@Component({
  selector: 'app-benefits-requirements',
  standalone: true,
  imports: [CommonModule, RouterLink, ContainerComponent],
  templateUrl: './benefits-requirements.component.html',
  styleUrl: './benefits-requirements.component.scss'
})
export class BenefitsRequirementsComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('benefitsRequirements', { static: false }) benefitsRequirements?: ElementRef;

  constructor(private analyticsService: AnalyticsService) {}

  ngOnInit() {
    // No necesita tracking de página aquí, se maneja en la página padre
  }

  ngAfterViewInit() {
    // Registrar la sección para tracking de analytics
    if (this.benefitsRequirements?.nativeElement) {
      this.analyticsService.registerSectionForTracking(
        this.benefitsRequirements.nativeElement,
        'Benefits Requirements',
        'benefits-requirements-section'
      );
    }
  }

  ngOnDestroy() {
    // Cleanup si es necesario
  }

  // Método para trackear click en CTA principal
  onCTAClick(): void {
    this.analyticsService.trackCTAClick(
      'Solicita tu Unipay aquí',
      'Benefits Requirements',
      'button',
      { url: 'https://www.unipay.cl/autoatencion-ptoventa/validar-identidad' }
    );
  }

  // Método para trackear click en enlace de bases legales
  onBasesLegalesClick(): void {
    this.analyticsService.trackLinkClick(
      'Revisar bases legales',
      '/bases-legales',
      'Benefits Requirements',
      false
    );
  }
}
